// extracted by mini-css-extract-plugin
export default {"warningModal":"ReportDraft_warningModal__dm1D-","buttonWrapper":"ReportDraft_buttonWrapper__WimhM"};